var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',{attrs:{"bg-class":"tw-bg-orange-100","text-class":"tw-text-orange-900"}},[_vm._v("\n  "+_vm._s(_vm.$t('foreign number plate'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }